import { paginationProps, getOrDeleteRequest, postOrPutRequest, customSwal } from '../../utils/utils';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import PreloaderTables from './PreloaderTables';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCircleCheck, faCircleMinus, faCirclePlus, faCircleXmark, faCreditCard, faDoorOpen, faDownload, faEdit, faEye, faMessage, faUndo, faUserCircle, faUserMinus, faUserPlus, faX, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getSession } from '../../utils/utils';
// import exportFromJSON from 'export-from-json';
import { useEffect, useState } from 'react';

const DataTableComponent = ({ columns, data, loading, button, buttonPersonalizado, toView, toEdit, toDelete, toDisable, toEnable, toUnverify, toVerify, toRestore, reload, toComments, toVisits, nameTable = 'Datos' }) => {
    const [role, setRole] = useState(null);
    
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(10);
    const [searchText, setSearchText] = useState(null);

    const tableData = {
        columns,
        data: data.data ?? [],
    };

    useEffect(() => {
        const loadRole = async () => {
            const session = await getSession();
            console.log(session, "session en datatable");
            setRole(session.role);
        };

        loadRole();
    }, []);

    useEffect(() => {
        reload(currentPage, totalItems, searchText);
    }, [currentPage, totalItems, searchText]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newPerPage, page) => {
        setTotalItems(newPerPage);
    };

    const handleSearch = (searchText) => {
        let searchInput = document.getElementById('searchInput');

        if (searchInput) {
            searchText = searchInput.value;
        } else {
            searchText = searchText || '';
        }

        setSearchText(searchText ? searchText.trim() : null);
    };

    // useEffect(() => {
    //     if (nameTable === 'Vendedores') {
    //         getMemberships();
    //     }
    // }, [nameTable]);

    useEffect(() => {
        setTotalPages(data.total);
    }, [data]);

    const exportToExcel = () => {
        const dataToExport = data.data.map(row => {
            let rowData = {};
            columns.forEach(column => {
                // console.log(column.selector);
                if (column.selector == 'photo_binary'
                    || column.name == 'Foto de perfil'
                    || column.selector == 'photo'
                    || column.selector == 'image'
                    || column.name == 'Imagen de perfil') return;

                const value = typeof column.selector === "function"
                    ? column.selector(row)
                    : row[column.selector];

                rowData[column.name] = value;
            });
            return rowData;
        });

        const fileName = `${nameTable}_${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}`;
        const exportType = 'xls';

        // exportFromJSON({ data: dataToExport, fileName, exportType });
    };

    const restoreUser = async (e) => {
        e.preventDefault();
        customSwal.fire({
            title: '¿Estás seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, restaurar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                customSwal.fire({
                    title: 'Cargando...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        customSwal.showLoading();
                    }
                });
                let response = await postOrPutRequest(
                    `${toRestore}${e.target.id}`,
                    'PUT',
                );
                if (response.type === 'success') {
                    setCurrentPage(1);
                    reload && reload(1);
                    customSwal.fire({
                        title: response.message,
                        icon: 'success',
                        confirmButtonText: 'Aceptar',
                        timer: 3000
                    });
                } else {
                    customSwal.fire({
                        title: response.message,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }
        });
    };

    const enableOrDisable = async (e, status) => {
        e.preventDefault();
        customSwal.fire({
            title: 'Cargando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                customSwal.showLoading();
            }
        });
        let response = await postOrPutRequest(
            `${status == 1 ? toDisable : toEnable}${e.target.id}`,
            'PUT',
        );
        if (response.type === 'success') {
            setCurrentPage(1);
            reload && reload(1);
            customSwal.fire({
                title: response.message,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            });
        } else {
            customSwal.fire({
                title: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const verifyOrUnverify = async (e, status) => {
        e.preventDefault();
        customSwal.fire({
            title: 'Cargando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                customSwal.showLoading();
            }
        });
        let response = await postOrPutRequest(
            `${status == 1 ? toUnverify : toVerify}${e.target.id}`,
            'PUT',
        );
        if (response.type === 'success') {
            setCurrentPage(1);
            reload && reload(1);
            customSwal.fire({
                title: response.message,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            });
        } else {
            customSwal.fire({
                title: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const eliminar = async (e) => {
        e.preventDefault();
        customSwal.fire({
            title: '¿Estás seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminarlo',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                customSwal.fire({
                    title: 'Cargando...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        customSwal.showLoading();
                    }
                });
                let response = await getOrDeleteRequest(
                    `${toDelete}${e.target.id}`,
                    'DELETE',
                );
                if (response.type === 'success') {
                    setCurrentPage(1);
                    reload && reload(1);
                    customSwal.fire({
                        title: response.message,
                        icon: 'success',
                        confirmButtonText: 'Aceptar',
                        timer: 3000
                    });
                } else {
                    customSwal.fire({
                        title: response.message,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }
        });
    };

    const expandedComponent = ({ data }) => {
        if (window.location.pathname === '/Usuarios' && data.id === 1) {
            return null;
        }

        return <div className="flex py-2 px-12" role="menu" aria-orientation="vertical" aria-labelledby="dropdown-button">
            {buttonPersonalizado && buttonPersonalizado(data)}
            {toView && <Link
                to={`${toView}${data.id}`}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-base text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faUserCircle} /> Ver
            </Link>}

            {/* {(toComments && [1, 2].includes(role)) && <Link
                to={`${toComments}${data.id}`}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faMessage} /> Comentarios
            </Link>} */}

            {/* {(toVisits && [1, 2].includes(role)) && <Link
                to={`${toVisits}${data.id}`}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faDoorOpen} /> Recorridos
            </Link>} */}

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            {(toEdit && ["Admin", "Empresa"].includes(role)) && <Link
                to={`${toEdit}${data.id}`}
                className="flex items-center bg-[#0E7FA0] hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-base text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faEdit} /> Editar
            </Link>}

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            {(toDisable && ["Admin", "Empresa"].includes(role)) && <button
                id={data.id}
                onClick={(e) => { enableOrDisable(e, data.status) }}
                className="flex items-center bg-orange-600 hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-base text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={
                    data.status === 1
                        ? faUserMinus
                        : faUserPlus
                } /> {data.status === 1 ? 'Desactivar' : 'Activar'}
            </button>}

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            {/* {(toUnverify && [1, 2].includes(role)) && <button
                id={data.id}
                onClick={(e) => { verifyOrUnverify(e, data.verified) }}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={
                    data.verified === 1
                        ? faCircleXmark
                        : faCircleCheck
                } /> {data.verified === 1 ? 'Quitar verificación' : 'Verificar'}
            </button>} */}

            {/* Solo permitido para usuarios con rol de administrador */}
            {(toDelete && ["Admin", "Empresa"].includes(role)) && <button
                id={data.id}
                onClick={(e) => { eliminar(e) }}
                className="flex items-center bg-red-600 hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-base text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faTrash} /> Eliminar
            </button>}

            {/* Solo permitido para usuarios con rol de administrador */}
            {(toRestore && ["Admin"].includes(role)) && <button
                id={data.id}
                onClick={(e) => { restoreUser(e) }}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-base text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faUndo} /> Restaurar
            </button>}
        </div>;
    };

    return (
        <div id="datatable-content" className="relative w-full">
            {/* Agregamos input de búsqueda */}
            <div className="flex justify-between items-center pt-16 pb-5 sm:py-6 md:py-5">
                <div className="flex items-center">
                    <input
                        type="text"
                        placeholder="Buscar..."
                        id="searchInput"
                        name="searchInput"
                        className="border border-gray-300 rounded-lg px-4 py-2 mr-2 ml-4 outline-none focus:ring-DarkBlue"
                    />
                    <button
                        type="button"
                        onClick={handleSearch}
                        className="bg-[#0E7FA0] hover:opacity-90 rounded-lg px-4 py-2 text-sm text-white cursor-pointer"
                    >
                        Buscar
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setSearchText(null);
                            document.getElementById('searchInput').value = '';
                            reload(1, totalItems, null);
                        }}
                        className="bg-[#FECB17] hover:bg-[#ac8a13] rounded-lg px-4 py-2 text-sm transition-colors cursor-pointer ml-2 hover:text-white"
                    >
                        Limpiar
                    </button>
                </div>
            </div>
            <DataTableExtensions
                {...tableData}
                filter={false}
                filterPlaceholder={"Buscar"}
                print={false}
                export={false}
            >
                <DataTable
                    columns={columns}
                    data={!loading && data.data.length > 0 ? data.data : []}
                    noHeader
                    defaultSortAsc={false}
                    pagination
                    paginationServer
                    paginationTotalRows={totalPages}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    progressPending={loading}
                    progressComponent={<PreloaderTables />}
                    highlightOnHover
                    paginationComponentOptions={paginationProps}
                    paginationDefaultPage={currentPage}
                    responsive
                    noDataComponent={<span className="font-bold text-black my-5">
                        No se encontraron registros
                    </span>}
                    expandableRows={["Admin", "Empresa"].includes(role) ? toView || toEdit || toDelete || toDisable || toEnable || toRestore || buttonPersonalizado || toComments : false}
                    expandableRowsComponent={expandedComponent}
                />
            </DataTableExtensions>

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            <div className='absolute top-0 right-0 p-5'>
                {/* {(button && [1, 2].includes(role)) && button} */}
                {/* <button onClick={exportToExcel} className="bg-DarkBlue hover:opacity-90 rounded-lg px-4 py-2 mx-1 text-sm text-white cursor-pointer">
                    Exportar <FontAwesomeIcon icon={faDownload} />
                </button> */}
            </div>
        </div>
    )
}

export default DataTableComponent;